import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogService } from 'src/app/services/dialog.service';
import { LayoutService } from 'src/app/services/layout.service';
import { ModalService } from 'src/app/services/modal.service';
import { PlanogramApiService } from 'src/app/services/planogram-api.service';
import { ToastService } from 'src/app/services/toasts.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-import-products-modal',
    templateUrl: './import-products-modal.component.html',
    styleUrl: './import-products-modal.component.scss',
    imports: [FormsModule]
})
export class ImportProductsModalComponent {
  barcodes: string[] = [];
  newBarcode: string = '';

constructor(
    public activeModal: NgbActiveModal,
    private planogramApiService: PlanogramApiService,
    private layoutService: LayoutService,
    private toastService: ToastService,
    private dialogService: DialogService
  ) { }

  addBarcode(): void {
    if (this.newBarcode && !this.barcodes.includes(this.newBarcode)) {
      if (this.productExists(this.newBarcode)) {
        this.toastService.show('Product already exists in planogram', {
          classname: 'bg-warning text-dark p-3 fs-5',
          delay: 3000
        });
        return;
      }
      this.barcodes.push(this.newBarcode);
      this.newBarcode = '';
    }
  }

  removeBarcode(barcode: string): void {
    this.barcodes = this.barcodes.filter(b => b !== barcode);
  }

  productExists(barcode: string): boolean {
    let exists = false;
    this.layoutService.planogramItems.forEach(item => {
      if (item.barcode == barcode)
        exists = true;
    });
    return exists;
  }

  async confirm() {
    try {
      const importedProducts = await this.planogramApiService.importProducts(this.barcodes);
      this.toastService.show('Products imported successfully', {
        classname: 'bg-success text-light p-3 fs-5',
        delay: 3000
      });
      this.layoutService.importProducts(importedProducts);
      this.activeModal.close(importedProducts);
    } catch (error: any) {
      await this.dialogService.showError(error.message || 'Failed to import products');
      console.error('Import products error:', error);
    }
  }

  cancel(): void {
    this.activeModal.close(null);
  }
}
